/* eslint-disable */
// 获取用户信息
export const user = state => {
  return state.user
}

export const areas = state => {
  return state.areas
}

export const cars = state => {
  return state.cars
}

export const categories = state => {
  return state.categories
}

export const messages = state => {
  return state.messages
}

export const areasLevel2 = state => {
  return state.areasLevel2
}


//我的足迹列表
export const tracks = state => {
  return state.tracks
}

//我的收藏列表
export const collects = state => {
  return state.collects
}

//我的收藏列表
export const collectsStore = state => {
  return state.collectsStore
}

//资讯分类列表
export const articleCategories = state => {
  return state.articleCategories
}

//获取纱线下的属性
export const attrs = state => {
  return state.attrs
}


